(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tbs-seller-intake"] && !Shopify.designMode) return;
  try {
    
(() => {
  const bind = () => document.querySelectorAll('[data-seller-form]').forEach(form => {
    if (form.dataset.bound) return;
    form.dataset.bound = 'true';
    const button = form.querySelector('[type="submit"]');
    const status = form.querySelector('[role="status"]');
    button.disabled = false;
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (form.dataset.busy || !form.reportValidity()) return;
      const files = [...form.querySelectorAll('[type="file"]')].flatMap(input => [...input.files]);
      if (files.some(file => file.size > 5 * 1024 * 1024 || !['image/jpeg', 'image/png', 'image/webp'].includes(file.type))) {
        status.textContent = form.dataset.photoError;
        return;
      }
      form.dataset.busy = 'true';
      button.disabled = true;
      status.textContent = form.dataset.sending;
      try {
        const endpoint = form.action;
        const tokenResponse = await fetch(endpoint + '/token', { credentials: 'omit', cache: 'no-store' });
        if (!tokenResponse.ok) throw new Error('connection');
        const session = await tokenResponse.json();
        const data = new FormData(form);
        for (const [name, value] of [...data]) {
          if (value instanceof File && !value.name) data.delete(name);
        }
        const response = await fetch(endpoint, {
          method: 'POST', credentials: 'omit', headers: { 'X-Intake-Token': session.token }, body: data
        });
        if (!response.ok) throw new Error('submission');
        status.textContent = form.dataset.success;
        form.querySelectorAll('input,select,textarea').forEach(input => input.disabled = true);
      } catch {
        status.textContent = form.dataset.error;
        delete form.dataset.busy;
        button.disabled = false;
      }
    });
  });
  bind();
  document.addEventListener('shopify:section:load', bind);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tbs-seller-test-oct15"] && !Shopify.designMode) return;
  try {
    
(() => {
  const bind = () => document.querySelectorAll('[data-seller-test-form]').forEach(form => {
    if (form.dataset.bound) return;
    form.dataset.bound = 'true';
    const button = form.querySelector('[type="submit"]');
    const status = form.querySelector('[role="status"]');
    button.disabled = false;
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (form.dataset.busy || !form.reportValidity()) return;
      const files = [...form.querySelectorAll('[type="file"]')].flatMap(input => [...input.files]);
      if (files.some(file => file.size > 5 * 1024 * 1024 || !['image/jpeg', 'image/png', 'image/webp'].includes(file.type))) {
        status.textContent = form.dataset.photoError;
        return;
      }
      form.dataset.busy = 'true';
      button.disabled = true;
      status.textContent = form.dataset.sending;
      try {
        const endpoint = form.action;
        const tokenResponse = await fetch(endpoint + '/token', { credentials: 'omit', cache: 'no-store' });
        if (!tokenResponse.ok) throw new Error('connection');
        const session = await tokenResponse.json();
        const data = new FormData(form);
        for (const [name, value] of [...data]) {
          if (value instanceof File && !value.name) data.delete(name);
        }
        const response = await fetch(endpoint, {
          method: 'POST', credentials: 'omit', headers: { 'X-Intake-Token': session.token }, body: data
        });
        if (!response.ok) throw new Error('submission');
        status.textContent = form.dataset.success;
        form.querySelectorAll('input,select,textarea').forEach(input => input.disabled = true);
      } catch {
        status.textContent = form.dataset.error;
        delete form.dataset.busy;
        button.disabled = false;
      }
    });
  });
  bind();
  document.addEventListener('shopify:section:load', bind);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-banner"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  const button = event.target.closest('[data-tbs-video-toggle]');
  if (!button) return;
  const video = button.closest('.banner').querySelector('video');
  if (!video) return;
  if (video.paused) {
    video.play().then(function() {
      button.textContent = button.dataset.pause;
      button.setAttribute('aria-pressed', 'false');
    }).catch(function() {});
  } else {
    video.pause();
    button.textContent = button.dataset.play;
    button.setAttribute('aria-pressed', 'true');
  }
});

  } catch(e) { console.error(e); }
})();
})();
